import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { PageCTA } from '../components/PageCTA';
import { Layout, Smartphone, Share2, CheckCircle2, Zap, Target, Search, Settings, QrCode, RefreshCw, ImageIcon, MessageCircle, TrendingUp, Utensils, Flame, Coffee, ShoppingBag, Plus } from 'lucide-react';
export function ServicesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-24 bg-[#0a0a0a] min-h-screen" data-id="element-706">
      {/* Page Header */}
      <section className="py-20 border-b border-white/[0.05]" data-id="element-707">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl text-center" data-id="element-708">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-709">
            <h1 className="text-4xl md:text-5xl font-medium text-white mb-6 tracking-tight" data-id="element-710">
              Infraestructura Digital Integral
            </h1>
            <p className="text-lg text-gray-400 leading-relaxed font-normal max-w-2xl mx-auto" data-id="element-711">
              Desarrollamos ecosistemas interconectados. Tu plataforma web,
              catálogos interactivos y canales de adquisición social operan en
              sincronía absoluta para maximizar la conversión 24/7.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Service 1: Web */}
      <section className="py-20 border-b border-white/[0.05]" data-id="element-712">
        <div className="container mx-auto px-6 md:px-12 max-w-5xl" data-id="element-713">
          <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-714">
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="w-full lg:w-1/2" data-id="element-715">
              <div className="w-12 h-12 rounded-xl bg-white/[0.03] border border-white/[0.05] flex items-center justify-center text-gray-400 mb-6" data-id="element-716">
                <Layout size={24} data-id="element-717" />
              </div>
              <h2 className="text-3xl font-medium text-white mb-6 tracking-tight" data-id="element-718">
                Plataformas Web de Alto Rendimiento
              </h2>
              <div className="space-y-6 text-gray-400 text-[15px] leading-relaxed mb-8" data-id="element-719">
                <p data-id="element-720">
                  Tu plataforma web es el núcleo de tu infraestructura digital.
                  Implementamos arquitecturas de información avanzadas y
                  experiencias sin fricción diseñadas para transformar tráfico
                  en ingresos predecibles.
                </p>
                <div className="card-premium !rounded-xl p-5 flex gap-4" data-id="element-721">
                  <div className="shrink-0 mt-0.5" data-id="element-722">
                    <CheckCircle2 className="text-brand-emerald" size={18} data-id="element-723" />
                  </div>
                  <p className="text-sm" data-id="element-724">
                    <strong className="text-white font-medium" data-id="element-725">
                      100% a medida.
                    </strong>{' '}
                    No usamos plantillas. Adaptamos tus ideas a la realidad
                    digital, construyendo desde cero una plataforma exclusiva.
                  </p>
                </div>
              </div>

              <div className="flex flex-wrap gap-2" data-id="element-726">
                <span className="inline-flex items-center px-3 py-1.5 rounded-md bg-white/[0.03] border border-white/[0.05] text-gray-400 text-[11px] font-medium uppercase tracking-wider" data-id="element-727">
                  SEO Optimizado
                </span>
                <span className="inline-flex items-center px-3 py-1.5 rounded-md bg-white/[0.03] border border-white/[0.05] text-gray-400 text-[11px] font-medium uppercase tracking-wider" data-id="element-728">
                  Mobile First
                </span>
                <span className="inline-flex items-center px-3 py-1.5 rounded-md bg-brand-emerald/10 text-brand-emerald text-[11px] font-medium uppercase tracking-wider" data-id="element-729">
                  Conversión +120%
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="w-full lg:w-1/2" data-id="element-730">
              {/* Visual Browser Mockup */}
              <div className="card-premium !overflow-hidden" data-id="element-731">
                {/* Browser Chrome */}
                <div className="bg-[#0a0a0a] border-b border-white/[0.05] px-4 py-3 flex items-center gap-4" data-id="element-732">
                  <div className="flex gap-1.5" data-id="element-733">
                    <div className="w-2.5 h-2.5 rounded-full bg-white/10" data-id="element-734"></div>
                    <div className="w-2.5 h-2.5 rounded-full bg-white/10" data-id="element-735"></div>
                    <div className="w-2.5 h-2.5 rounded-full bg-white/10" data-id="element-736"></div>
                  </div>
                  <div className="flex-1 bg-white/[0.02] rounded-md h-6 border border-white/[0.05] flex items-center px-3" data-id="element-737">
                    <Search size={12} className="text-gray-600 mr-2" data-id="element-738" />
                    <div className="w-24 h-1.5 bg-white/10 rounded-full" data-id="element-739"></div>
                  </div>
                </div>

                {/* Browser Content */}
                <div className="p-8" data-id="element-740">
                  <div className="flex items-center justify-between mb-8" data-id="element-741">
                    <div data-id="element-742">
                      <div className="text-[11px] font-medium text-gray-500 uppercase tracking-wider mb-1" data-id="element-743">
                        Crecimiento de Conversión
                      </div>
                      <div className="text-3xl font-medium text-white tracking-tight" data-id="element-744">
                        +124%
                      </div>
                    </div>
                    <div className="w-10 h-10 rounded-xl bg-white/[0.03] flex items-center justify-center text-gray-400 border border-white/[0.05]" data-id="element-745">
                      <Target size={20} data-id="element-746" />
                    </div>
                  </div>

                  {/* Clean Chart */}
                  <div className="h-32 flex items-end gap-2 mb-8" data-id="element-747">
                    {[30, 45, 40, 65, 80, 100].map((height, i) => <div key={i} className="flex-1 bg-brand-emerald/20 rounded-t-sm relative group hover:bg-brand-emerald/40 transition-colors" style={{
                    height: `${height}%`
                  }} data-id="element-748"></div>)}
                  </div>

                  {/* Stat Pills */}
                  <div className="flex flex-wrap gap-2" data-id="element-749">
                    <div className="bg-white/[0.02] border border-white/[0.05] rounded-md px-3 py-1.5 flex items-center gap-2 text-[12px] text-gray-400" data-id="element-750">
                      <Zap size={12} className="text-gray-500" data-id="element-751" /> Carga &lt;1s
                    </div>
                    <div className="bg-white/[0.02] border border-white/[0.05] rounded-md px-3 py-1.5 flex items-center gap-2 text-[12px] text-gray-400" data-id="element-752">
                      <Search size={12} className="text-gray-500" data-id="element-753" /> SEO 95/100
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Service 2: Menu/Catalog */}
      <section className="py-20 border-b border-white/[0.05]" data-id="element-754">
        <div className="container mx-auto px-6 md:px-12 max-w-5xl" data-id="element-755">
          <div className="flex flex-col lg:flex-row-reverse gap-12 items-center" data-id="element-756">
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="w-full lg:w-1/2" data-id="element-757">
              <div className="w-12 h-12 rounded-xl bg-white/[0.03] border border-white/[0.05] flex items-center justify-center text-gray-400 mb-6" data-id="element-758">
                <Smartphone size={24} data-id="element-759" />
              </div>
              <h2 className="text-3xl font-medium text-white mb-6 tracking-tight" data-id="element-760">
                Menús Digitales Avanzados
              </h2>
              <div className="space-y-6 text-gray-400 text-[15px] leading-relaxed mb-8" data-id="element-761">
                <p data-id="element-762">
                  Creamos menús digitales avanzados y 100% personalizables a las
                  necesidades de tu negocio. Acceso instantáneo vía QR,
                  actualizaciones en tiempo real y presentación visual limpia.
                </p>
                <div className="card-premium !rounded-xl p-5 flex gap-4" data-id="element-763">
                  <div className="shrink-0 mt-0.5" data-id="element-764">
                    <CheckCircle2 size={18} className="text-brand-emerald" data-id="element-765" />
                  </div>
                  <p className="text-sm" data-id="element-766">
                    <strong className="text-white font-medium" data-id="element-767">
                      Diseño exclusivo.
                    </strong>{' '}
                    Cada elemento visual se diseña pensando en tu marca,
                    mejorando la percepción de valor.
                  </p>
                </div>
              </div>

              <div className="flex flex-wrap gap-2" data-id="element-768">
                <span className="inline-flex items-center px-3 py-1.5 rounded-md bg-white/[0.03] border border-white/[0.05] text-gray-400 text-[11px] font-medium uppercase tracking-wider" data-id="element-769">
                  Acceso QR
                </span>
                <span className="inline-flex items-center px-3 py-1.5 rounded-md bg-white/[0.03] border border-white/[0.05] text-gray-400 text-[11px] font-medium uppercase tracking-wider" data-id="element-770">
                  100% Personalizable
                </span>
                <span className="inline-flex items-center px-3 py-1.5 rounded-md bg-brand-emerald/10 text-brand-emerald text-[11px] font-medium uppercase tracking-wider" data-id="element-771">
                  Interacción +3x
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="w-full lg:w-1/2" data-id="element-772">
              {/* Visual Phone Mockup */}
              <div className="relative max-w-[280px] mx-auto" data-id="element-773">
                <div className="bg-[#0a0a0a] border-[6px] border-[#1a1a1a] rounded-[2.5rem] overflow-hidden relative ring-1 ring-white/[0.05]" data-id="element-774">
                  {/* Phone Notch */}
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-5 bg-[#1a1a1a] rounded-b-xl z-30" data-id="element-775"></div>

                  {/* Phone Header */}
                  <div className="bg-[#111] pt-10 pb-4 px-5 border-b border-white/[0.05] relative z-20" data-id="element-776">
                    <div className="flex justify-between items-center mb-4" data-id="element-777">
                      <div className="w-8 h-8 rounded-full bg-white/[0.05] flex items-center justify-center text-gray-400" data-id="element-778">
                        <QrCode size={14} data-id="element-779" />
                      </div>
                      <div className="flex gap-2" data-id="element-780">
                        <div className="w-8 h-8 rounded-full bg-white/[0.05] flex items-center justify-center text-gray-400" data-id="element-781">
                          <Search size={14} data-id="element-782" />
                        </div>
                        <div className="w-8 h-8 rounded-full bg-white/[0.05] flex items-center justify-center text-gray-400" data-id="element-783">
                          <ShoppingBag size={14} data-id="element-784" />
                        </div>
                      </div>
                    </div>
                    <div className="text-white font-medium text-xl tracking-tight" data-id="element-785">
                      Nuestra Carta
                    </div>
                  </div>

                  {/* Phone Content */}
                  <div className="p-4 space-y-2 bg-[#0a0a0a] h-[320px] relative z-10" data-id="element-786">
                    {[{
                    name: 'Hamburguesa Trufada',
                    price: '14,00€',
                    icon: <Flame size={14} data-id="element-787" />
                  }, {
                    name: 'Pizza Gourmet',
                    price: '16,00€',
                    icon: <Utensils size={14} data-id="element-788" />
                  }, {
                    name: 'Tacos de Costilla',
                    price: '12,00€',
                    icon: <Flame size={14} data-id="element-789" />
                  }, {
                    name: 'Tarta de Queso',
                    price: '8,00€',
                    icon: <Coffee size={14} data-id="element-790" />
                  }].map((item, i) => <div key={i} className="flex items-center gap-3 p-3 rounded-xl bg-[#111] border border-white/[0.05]" data-id="element-791">
                        <div className="w-10 h-10 rounded-lg bg-white/[0.03] flex items-center justify-center text-gray-500 shrink-0" data-id="element-792">
                          {item.icon}
                        </div>
                        <div className="flex-1 min-w-0" data-id="element-793">
                          <div className="text-white text-[13px] font-medium truncate" data-id="element-794">
                            {item.name}
                          </div>
                          <div className="text-gray-500 text-[11px] tabular-nums" data-id="element-795">
                            {item.price}
                          </div>
                        </div>
                        <div className="w-6 h-6 rounded-md bg-white/[0.05] flex items-center justify-center text-gray-400 shrink-0" data-id="element-796">
                          <Plus size={12} data-id="element-797" />
                        </div>
                      </div>)}
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Service 3: Social */}
      <section className="py-20 border-b border-white/[0.05]" data-id="element-798">
        <div className="container mx-auto px-6 md:px-12 max-w-5xl" data-id="element-799">
          <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-800">
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="w-full lg:w-1/2" data-id="element-801">
              <div className="w-12 h-12 rounded-xl bg-white/[0.03] border border-white/[0.05] flex items-center justify-center text-gray-400 mb-6" data-id="element-802">
                <Share2 size={24} data-id="element-803" />
              </div>
              <h2 className="text-3xl font-medium text-white mb-6 tracking-tight" data-id="element-804">
                Ecosistemas Sociales Conectados
              </h2>
              <div className="space-y-6 text-gray-400 text-[15px] leading-relaxed mb-8" data-id="element-805">
                <p data-id="element-806">
                  Creamos y configuramos tus perfiles en redes sociales,
                  sincronizados con tu página web para una imagen profesional y
                  coherente.
                </p>
                <div className="card-premium !rounded-xl p-5 flex gap-4" data-id="element-807">
                  <div className="shrink-0 mt-0.5" data-id="element-808">
                    <CheckCircle2 size={18} className="text-brand-emerald" data-id="element-809" />
                  </div>
                  <p className="text-sm" data-id="element-810">
                    <strong className="text-white font-medium" data-id="element-811">
                      Reputación digital impecable.
                    </strong>{' '}
                    Aseguramos que la primera impresión de tus clientes sea
                    perfecta.
                  </p>
                </div>
              </div>

              <div className="flex flex-wrap gap-2" data-id="element-812">
                <span className="inline-flex items-center px-3 py-1.5 rounded-md bg-white/[0.03] border border-white/[0.05] text-gray-400 text-[11px] font-medium uppercase tracking-wider" data-id="element-813">
                  Imagen Coherente
                </span>
                <span className="inline-flex items-center px-3 py-1.5 rounded-md bg-white/[0.03] border border-white/[0.05] text-gray-400 text-[11px] font-medium uppercase tracking-wider" data-id="element-814">
                  Sincronización Web
                </span>
                <span className="inline-flex items-center px-3 py-1.5 rounded-md bg-brand-emerald/10 text-brand-emerald text-[11px] font-medium uppercase tracking-wider" data-id="element-815">
                  Alcance +85%
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="w-full lg:w-1/2" data-id="element-816">
              {/* Dashboard Mockup */}
              <div className="card-premium !overflow-hidden max-w-md mx-auto" data-id="element-817">
                <div className="bg-[#0a0a0a] border-b border-white/[0.05] px-5 py-4 flex items-center justify-between" data-id="element-818">
                  <div className="flex items-center gap-3" data-id="element-819">
                    <div className="w-8 h-8 rounded-lg bg-white/[0.05] flex items-center justify-center text-gray-400" data-id="element-820">
                      <Share2 size={14} data-id="element-821" />
                    </div>
                    <div data-id="element-822">
                      <div className="text-white font-medium text-[13px]" data-id="element-823">
                        Ecosistema Social
                      </div>
                      <div className="text-gray-500 text-[10px] uppercase tracking-wider" data-id="element-824">
                        Panel de Control
                      </div>
                    </div>
                  </div>
                  <div className="px-2 py-1 rounded bg-brand-emerald/10 text-brand-emerald text-[10px] font-medium uppercase tracking-wider" data-id="element-825">
                    Activo
                  </div>
                </div>

                <div className="p-5" data-id="element-826">
                  <div className="space-y-2 mb-5" data-id="element-827">
                    {['Instagram', 'Facebook', 'WhatsApp Business'].map((platform, i) => <div key={i} className="flex items-center justify-between p-3 rounded-xl bg-[#0a0a0a] border border-white/[0.05]" data-id="element-828">
                          <div className="text-gray-300 text-[13px] font-medium" data-id="element-829">
                            {platform}
                          </div>
                          <div className="text-gray-500 text-[11px]" data-id="element-830">
                            Conectado
                          </div>
                        </div>)}
                  </div>

                  <div className="grid grid-cols-3 gap-2" data-id="element-831">
                    <div className="p-3 rounded-xl bg-[#0a0a0a] border border-white/[0.05] text-center" data-id="element-832">
                      <div className="text-white font-medium text-base mb-0.5" data-id="element-833">
                        +85%
                      </div>
                      <div className="text-gray-500 text-[10px] uppercase tracking-wider" data-id="element-834">
                        Alcance
                      </div>
                    </div>
                    <div className="p-3 rounded-xl bg-[#0a0a0a] border border-white/[0.05] text-center" data-id="element-835">
                      <div className="text-white font-medium text-base mb-0.5" data-id="element-836">
                        3x
                      </div>
                      <div className="text-gray-500 text-[10px] uppercase tracking-wider" data-id="element-837">
                        Engage
                      </div>
                    </div>
                    <div className="p-3 rounded-xl bg-[#0a0a0a] border border-white/[0.05] text-center" data-id="element-838">
                      <div className="text-white font-medium text-base mb-0.5" data-id="element-839">
                        100%
                      </div>
                      <div className="text-gray-500 text-[10px] uppercase tracking-wider" data-id="element-840">
                        Sync
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <PageCTA data-id="element-841" />
    </div>;
}